import { gql } from '@apollo/client';

const QUERY_PRODUCT_WORK_COUNTS = gql`
  query ProductWorkCounts($productWorkId: ID!) {
    productWorkCounts(productWorkId: $productWorkId) {
      ordersCount
      expensesCount
      royaltiesCount
    }
  }
`;

export default QUERY_PRODUCT_WORK_COUNTS;